<div class="container-fluid fixed-top px-0">
    <!--<div class="top-bar row gx-0 align-items-center d-none d-lg-flex transition-topbar"  [class.topbar-hidden]="!isTopBarShow">
        <div class="col-lg-6 px-5 text-start jos">
            <small><i class="fa fa-map-marker-alt me-2"></i>123 Street, New York, USA</small>
            <small class="ms-4"><i class="fa fa-envelope me-2"></i>info@example.com</small>
        </div>
        <div class="col-lg-6 px-5 text-end">
            <small>Follow us:</small>
            <a class="text-body ms-3" href=""><i class="fab fa-facebook-f"></i></a>
            <a class="text-body ms-3" href=""><i class="fab fa-twitter"></i></a>
            <a class="text-body ms-3" href=""><i class="fab fa-linkedin-in"></i></a>
            <a class="text-body ms-3" href=""><i class="fab fa-instagram"></i></a>
        </div>
    </div>-->

    <nav #navbar class="navbar navbar-expand-lg py-lg-0 px-lg-5 wow fadeIn" data-wow-delay="0.1s"
         [ngClass]="!isTopBarShow ? 'navbar-animation' : 'navbar-transparent'">
        <a href="index.html" class="navbar-brand ms-4 ms-lg-0">
            <img src="assets/img/cktech.png" class="logo">
        </a>
        <button type="button" class="navbar-toggler me-4" (click)="toggleNavbar()">
            <span class="navbar-toggler-icon">
                <i class="bi bi-list h1" [ngClass]="isNavbarCollapsed ? 'text-black' : 'text-black'"></i>
            </span>
        </button>
        <div [ngClass]="{ 'collapse navbar-collapse': true, show: !isNavbarCollapsed }" id="navbarCollapse">
            <div class="navbar-nav ms-auto p-4 p-lg-0 text-dark">
                <a routerLink="/" fragment="home" class="nav-item nav-link active">Home</a>
                <a routerLink="/" fragment="about" class="nav-item nav-link">About Us</a>
                <a routerLink="/" fragment="pricing" class="nav-item nav-link">Pricing</a>
                <a routerLink="/" fragment="contact" class="nav-item nav-link">Contact Us</a>
                <a [routerLink]="['/login']" class="nav-item nav-link ml-2">
                    <i class="fas fa-sign-in-alt fa-lg mr-2"></i>
                    <span>Login</span>
                </a>
            </div>
        </div>
    </nav>
</div>

<section class="hero">
    <div class="container">
        <h1 class="display-5 fw-bold" data-aos="fade-right" data-aos-delay="800">Create Beautiful Invitations in
            Minutes</h1>
        <p class="lead mt-3" data-aos="fade-left" data-aos-delay="1200">Design and send stunning digital invites for any
            occasion — weddings, birthdays, baby showers,
            and more.</p>
    </div>
</section>

<!-- Features -->
<section class="py-5 bg-light" id="home" data-aos="fade-up-right" data-aos-delay="1400">
    <div class="container">
        <h2 class="section-title text-center">Everything You Need to Make Your Invitation Special</h2>
        <div class="row g-4">
            <div class="col-md-4">
                <div class="p-3 bg-white shadow rounded text-center" data-aos="zoom-in" data-aos-delay="1500">
                    <i class="bi bi-upload feature-icon"></i>
                    <h5 class="mt-3">Upload Your Own Invitation</h5>
                    <p>Already have a design? Upload it, add music, and share instantly—no design skills needed.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="p-3 bg-white shadow rounded text-center" data-aos="zoom-in" data-aos-delay="1550">
                    <i class="bi bi-music-note-beamed feature-icon"></i>
                    <h5 class="mt-3">Add Music to Set the Mood</h5>
                    <p>Upload your own track to add life and emotion to your invite.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="p-3 bg-white shadow rounded text-center" data-aos="zoom-in" data-aos-delay="1600">
                    <i class="bi bi-share feature-icon"></i>
                    <h5 class="mt-3">Share Instantly</h5>
                    <p>Get a link and share via WhatsApp, email, or social media—fast and easy!</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="p-3 bg-white shadow rounded text-center" data-aos="zoom-in" data-aos-delay="1650">
                    <i class="bi bi-phone feature-icon"></i>
                    <h5 class="mt-3">Need Custom Design Help?</h5>
                    <p>Let our experts create your dream invitation at a budget-friendly price.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="p-3 bg-white shadow rounded text-center" data-aos="zoom-in" data-aos-delay="1700">
                    <i class="bi bi-phone feature-icon"></i>
                    <h5 class="mt-3">Mobile-Friendly Experience</h5>
                    <p>All invites look great on phones, tablets, and desktops.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="p-3 bg-white shadow rounded text-center" data-aos="zoom-in" data-aos-delay="1750">
                    <i class="bi bi-patch-check feature-icon"></i>
                    <h5 class="mt-3">No Ads, No Watermarks</h5>
                    <p>Keep your invitation elegant and distraction-free, always.</p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Categories -->
<section class="py-5" id="about" data-aos="zoom-in-right">
    <div class="container text-center">
        <h2 class="section-title mb-4">Explore Our Templates</h2>
        <div class="row justify-content-center g-4">
            <!-- Category Card -->
            <div class="col-6 col-sm-4 col-md-3">
                <div class="category-card p-3 shadow-sm rounded text-center">
                    <i class="bi bi-heart-fill fs-1 text-danger"></i>
                    <p class="mt-2 mb-0 fw-semibold">Wedding Invitations</p>
                </div>
            </div>

            <div class="col-6 col-sm-4 col-md-3">
                <div class="category-card p-3 shadow-sm rounded text-center">
                    <i class="bi bi-gift-fill fs-1 text-pink"></i>
                    <p class="mt-2 mb-0 fw-semibold">Baby Shower</p>
                </div>
            </div>

            <div class="col-6 col-sm-4 col-md-3">
                <div class="category-card p-3 shadow-sm rounded text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="currentColor"
                         class="bi bi-cake2-fill text-primary fs-1" viewBox="0 0 16 16">
                        <path d="m2.899.804.595-.792.598.79A.747.747 0 0 1 4 1.806v4.886q-.532-.09-1-.201V1.813a.747.747 0 0 1-.1-1.01ZM13 1.806v4.685a15 15 0 0 1-1 .201v-4.88a.747.747 0 0 1-.1-1.007l.595-.792.598.79A.746.746 0 0 1 13 1.806m-3 0a.746.746 0 0 0 .092-1.004l-.598-.79-.595.792A.747.747 0 0 0 9 1.813v5.17q.512-.02 1-.055zm-3 0v5.176q-.512-.018-1-.054V1.813a.747.747 0 0 1-.1-1.01l.595-.79.598.789A.747.747 0 0 1 7 1.806"/>
                        <path d="M4.5 6.988V4.226a23 23 0 0 1 1-.114V7.16c0 .131.101.24.232.25l.231.017q.498.037 1.02.055l.258.01a.25.25 0 0 0 .26-.25V4.003a29 29 0 0 1 1 0V7.24a.25.25 0 0 0 .258.25l.259-.009q.52-.018 1.019-.055l.231-.017a.25.25 0 0 0 .232-.25V4.112q.518.047 1 .114v2.762a.25.25 0 0 0 .292.246l.291-.049q.547-.091 1.033-.208l.192-.046a.25.25 0 0 0 .192-.243V4.621c.672.184 1.251.409 1.677.678.415.261.823.655.823 1.2V13.5c0 .546-.408.94-.823 1.201-.44.278-1.043.51-1.745.696-1.41.376-3.33.603-5.432.603s-4.022-.227-5.432-.603c-.702-.187-1.305-.418-1.745-.696C.408 14.44 0 14.046 0 13.5v-7c0-.546.408-.94.823-1.201.426-.269 1.005-.494 1.677-.678v2.067c0 .116.08.216.192.243l.192.046q.486.116 1.033.208l.292.05a.25.25 0 0 0 .291-.247M1 8.82v1.659a1.935 1.935 0 0 0 2.298.43.935.935 0 0 1 1.08.175l.348.349a2 2 0 0 0 2.615.185l.059-.044a1 1 0 0 1 1.2 0l.06.044a2 2 0 0 0 2.613-.185l.348-.348a.94.94 0 0 1 1.082-.175c.781.39 1.718.208 2.297-.426V8.833l-.68.907a.94.94 0 0 1-1.17.276 1.94 1.94 0 0 0-2.236.363l-.348.348a1 1 0 0 1-1.307.092l-.06-.044a2 2 0 0 0-2.399 0l-.06.044a1 1 0 0 1-1.306-.092l-.35-.35a1.935 1.935 0 0 0-2.233-.362.935.935 0 0 1-1.168-.277z"/>
                    </svg>
                    <p class="mt-2 mb-0 fw-semibold">Birthday Parties</p>
                </div>
            </div>

            <div class="col-6 col-sm-4 col-md-3">
                <div class="category-card p-3 shadow-sm rounded text-center">
                    <i class="bi bi-stars fs-1 text-primary"></i>
                    <p class="mt-2 mb-0 fw-semibold">Anniversary</p>
                </div>
            </div>

            <div class="col-6 col-sm-4 col-md-3">
                <div class="category-card p-3 shadow-sm rounded text-center">
                    <i class="bi bi-briefcase-fill fs-1 text-dark"></i>
                    <p class="mt-2 mb-0 fw-semibold">Corporate Events</p>
                </div>
            </div>

            <div class="col-6 col-sm-4 col-md-3">
                <div class="category-card p-3 shadow-sm rounded text-center">
                    <i class="bi bi-house-door-fill fs-1 text-success"></i>
                    <p class="mt-2 mb-0 fw-semibold">Housewarming</p>
                </div>
            </div>

            <div class="col-6 col-sm-4 col-md-3">
                <div class="category-card p-3 shadow-sm rounded text-center">
                    <i class="bi bi-heart-fill fs-1 text-danger"></i>
                    <p class="mt-2 mb-0 fw-semibold">Religious Ceremonies</p>
                </div>
            </div>

            <div class="col-6 col-sm-4 col-md-3">
                <div class="category-card p-3 shadow-sm rounded text-center">
                    <i class="bi bi-pencil-fill fs-1 text-info"></i>
                    <p class="mt-2 mb-0 fw-semibold">Custom Events</p>
                </div>
            </div>

            <div class="col-12 mb-3 mt-3">
                <a routerLink="/register" class="btn btn-success">Sign up now</a>
            </div>
        </div>
    </div>
</section>

<div class="container-fluid my-5 py-6 bg-light bg-icon">
    <div class="container">
        <div class="section-header text-center mx-auto mb-5" data-aos="fade-right" data-aos-delay="200">
            <h1 class="display-5 mb-3 font-weight-bolder">Create & Share Invitations in 3 Simple Steps</h1>
        </div>
        <div class="row g-4">
            <div class="feature-grid">
                <div class="feature-box">
                    <i class="bi bi-file-earmark-image"></i>
                    <h5>1. Upload Your Invitation</h5>
                    <p>Use JPEG or PNG format. Already have a design? Upload it directly.</p>
                </div>
                <div class="feature-box">
                    <i class="bi bi-volume-up"></i>
                    <h5> 2. Add Background Music</h5>
                    <p>Upload your own audio for a more personal experience.</p>
                </div>
                <div class="feature-box">
                    <i class="bi bi-link"></i>
                    <h5>3. Generate & Share Your Link</h5>
                    <p>Instantly share your invite via WhatsApp, email, or social media.</p>
                </div>
            </div>

        </div>
    </div>
</div>

<!-- CTA Custom Design -->
<section class="cta-section" id="custom">
    <h3>Want a Custom Design?</h3>
    <p class="lead">Just share your ideas and we’ll design a beautiful invite that matches your vision.</p>
    <a href="#contact" class="btn btn-primary">Get a Custom Quote</a>
</section>


<!-- Pricing -->
<section class="py-5 bg-light" id="pricing">
    <div class="container text-center">
        <h2 class="section-title">Simple & Transparent Pricing</h2>
        <div class="row g-4">
            <div class="col-md-6">
                <div class="p-4 bg-white shadow rounded">
                    <h4>🎉 Free Plan</h4>
                    <p>Upload your design, add music, and get a shareable link — all at no cost!</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="p-4 bg-white shadow rounded">
                    <h4>✨ Custom Design</h4>
                    <p>Get a professionally designed invite. Contact us for a quote tailored to your needs.</p>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- Testimonials -->
<section class="py-5" id="testimonials">
    <div class="container">
        <h2 class="section-title text-center mb-4">What Our Users Say</h2>
        <div id="testimonialCarousel" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-inner">

                <div class="carousel-item active">
                    <div class="testimonial text-center">
                        <strong>Ritika S., Bride-to-be:</strong> <br>
                        “I uploaded my own invitation, added music, and shared the link in minutes. Everyone loved it!”
                    </div>
                </div>

                <div class="carousel-item">
                    <div class="testimonial text-center">
                        <strong>Ankit R., Event Organizer:</strong> <br>
                        “Shared my idea with their team and got a stunning custom invitation at a great price!”
                    </div>
                </div>

                <div class="carousel-item">
                    <div class="testimonial text-center">
                        <strong>Neha M., New Mom:</strong> <br>
                        “The ability to add music made our baby shower invite feel so special. Super simple to use!”
                    </div>
                </div>

                <div class="carousel-item">
                    <div class="testimonial text-center">
                        <strong>Vivek T., Birthday Host:</strong> <br>
                        “Highly recommend! The link-sharing feature is a game-changer!”
                    </div>
                </div>

            </div>

            <!-- Carousel controls -->
            <button class="carousel-control-prev" type="button" data-bs-target="#testimonialCarousel"
                    data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#testimonialCarousel"
                    data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>
        </div>
    </div>
</section>

<!-- Contact -->
<footer class="bg-white py-5">
    <div class="container">
        <!--<div class="row">
          <div class="col-lg-4 mb-4 mb-lg-0">
            <h5 class="text-uppercase mb-4">CkTech's Invites</h5>
            <p class="small">Design. Add Music. Share. Celebrate!</p>
            &lt;!&ndash;<div class="social-links mt-3">
                <a href="#" class="btn btn-outline-light btn-social rounded-circle"><i
                        class="fab fa-facebook-f"></i></a>
                <a href="#" class="btn btn-outline-light btn-social rounded-circle"><i
                        class="fab fa-twitter"></i></a>
                <a href="#" class="btn btn-outline-light btn-social rounded-circle"><i class="fab fa-instagram"></i></a>
                <a href="#" class="btn btn-outline-light btn-social rounded-circle"><i
                        class="fab fa-linkedin-in"></i></a>
            </div>&ndash;&gt;
          </div>
          <div class="col-lg-4 mb-4 mb-lg-0">
            &lt;!&ndash;<h5 class="text-uppercase mb-4">Quick Links</h5>
            <ul class="list-unstyled">
                <li class="mb-2"><a href="#" class="text-muted">Home</a></li>
                <li class="mb-2"><a href="#" class="text-muted">Shop</a></li>
                <li class="mb-2"><a href="#" class="text-muted">Services</a></li>
                <li class="mb-2"><a href="#" class="text-muted">About Us</a></li>
                <li class="mb-2"><a href="#" class="text-muted">Contact</a></li>
            </ul>&ndash;&gt;
          </div>
          <div class="col-lg-4">
            <h5 class="text-uppercase mb-4">Contact Us</h5>
            <p class="small mb-2">
              <i class="fas fa-envelope mr-2"></i>
              <a href="mailto:cktechsoln@gmail.com" class="text-dark text-decoration-none">
                cktechsoln&#64;gmail.com
              </a>
            </p>
            <p class="small mb-2">
              <i class="fas fa-phone mr-2"></i>
              <a href="tel:9003028550" class="text-decoration-none text-dark">
                9003028550
              </a>
            </p>
          </div>
        </div>-->
        <hr class="my-4 border-secondary">
        <div class="row">
            <div class="col-md-6 text-center text-md-left">
                <p class="small mb-0">&copy; {{currentYear}} CKTech Solutions. All rights reserved.</p>
            </div>
            <div class="col-md-6 text-center text-md-right">
                <p class="small mb-0">Designed & Developed by <a
                        href="https://cktechsoln.in/"
                        target="_blank"
                        rel="noopener noreferrer" class="text-primary"
                        style="margin: 0"
                >
                    CKTech Solution</a
                ></p>
            </div>
        </div>
    </div>
</footer>
